import React from "react";
import { SERVICES } from "../lib/site";
import * as Icons from "lucide-react";

export default function Services() {
  return (
    <section id="servizi" className="py-20 md:py-28 bg-white border-y border-brand-line" data-testid="services-section">
      <div className="container-page">
        <div className="max-w-2xl">
          <span className="eyebrow">I nostri servizi</span>
          <h2 className="heading-display text-3xl md:text-5xl mt-4">
            Una squadra, sei competenze. Un risultato unico.
          </h2>
          <p className="text-brand-mute mt-5 leading-relaxed">
            Dalla tinteggiatura al cappotto termico, dai terrazzi agli impianti:
            seguiamo il tuo progetto end-to-end con un unico interlocutore.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICES.map((s, i) => {
            const Icon = Icons[s.icon] || Icons.Wrench;
            return (
              <article
                key={s.key}
                className="card-tactile p-7 group hover:-translate-y-1 hover:shadow-md transition-all duration-300"
                data-testid={`service-card-${s.key}`}
              >
                <div className="flex items-start justify-between">
                  <div className="h-12 w-12 rounded-2xl bg-brand-bg flex items-center justify-center text-brand-terracotta group-hover:bg-brand-terracotta group-hover:text-white transition-colors">
                    <Icon className="h-6 w-6" />
                  </div>
                  <span className="text-xs text-brand-mute font-mono">0{i + 1}</span>
                </div>
                <h3 className="heading-display text-xl mt-6 leading-snug">{s.title}</h3>
                <p className="text-brand-mute text-sm mt-3 leading-relaxed">{s.desc}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
